import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://bdffjxntmbtxputzjgps.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_3w4jDUIwdhuB30hzWNMe4A_IWADFCEz';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use current domain for redirects (works in dev and production)
    redirectTo: typeof window !== 'undefined' ? window.location.origin : undefined,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
